module.exports = __webpack_public_path__ + "img/remove_circle_outline.3a34ea14.svg";